/* eslint-disable filenames/match-regex */
import { LINKS_GLOBAL_WOWCHER } from '../links/links';

export const SUBSCRIBER_TEST_IDS = {
  CLOSE_BUTTON: 'close-button',
  EMAIL_INPUT: 'email-input',
  ERROR_TEXT: 'error-text',
  GOOGLE_BUTTON: 'google-button',
  LOCATION_SELECT: 'location-select',
  LOGIN_BUTTON: 'login-button',
  SUBMIT_BUTTON: 'submit-button',
  SUBTITLE_TEXT: 'subtitle-text',
};

const DEFAULT_LINK =
  LINKS_GLOBAL_WOWCHER[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'][
    process.env.NEXT_PUBLIC_SITE || 'wowcher'
  ];

export const PPC_SIGN_UP = (buttonText = 'GO TO DEALS!') => ({
  'living-social': `By clicking “${buttonText}” you agree to receive daily emails featuring local service, shopping and travel offers from LivingSocial. 
                    You can change your preferences or unsubscribe at any time by visiting our email preference centre or by clicking on the unsubscribe option, both of which are links in each of our emails. 
                    Alternatively, to go directly to the site, go to <a id="homepage-link-track" href='${DEFAULT_LINK}'>www.livingsocial.co.uk</a> from your browser. View our Privacy & Cookie Policy <a
                    href='${DEFAULT_LINK}/page/privacypolicy'
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    here.</a>`,
  wowcher: `By clicking “${buttonText}” you agree to receive daily emails featuring local service, shopping and travel offers from Wowcher. 
            You can change your preferences or unsubscribe at any time by visiting our email preference centre or by clicking on the unsubscribe option, both of which are links in each of our emails. 
            Alternatively, to go directly to the site, go to <a id="homepage-link-track" href='${DEFAULT_LINK}'>www.wowcher.co.uk</a> from your browser. 
            View our Privacy & Cookie Policy <a
            href='${DEFAULT_LINK}/page/privacypolicy'
            target="_blank"
            rel="noreferrer noopener"
          >
            here</a>.`,
});
